<template>
  <div>
    <div
      v-if="!hasReviews && !pendingReviews && !reviewsError"
      class="my-32 flex flex-col items-center justify-center py-32"
    >
      <p class="body-1-bold mb-10">{{ i18n(translations.noReviewsText1) }}</p>
      <p class="body-2">{{ i18n(translations.noReviewsText2) }}</p>
    </div>

    <ReviewsBlock
      v-if="rating && hasReviews && !reviewsError"
      id="customer-reviews"
      :ai-summary="undefined"
      :ai-summary-pending="false"
      :next-reviews-cursor="reviews?.nextCursor"
      :pending-summary="ratingSummaryPending"
      :previous-reviews-cursor="reviews?.previousCursor"
      :product-id="undefined"
      :rating
      :rating-summary
      :reviews="reviews?.results || []"
      :reviews-pending="pendingReviews"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { Rating } from '@backmarket/http-api/src/api-specs-reviews/types/rating'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

import ReviewsBlock from '~/scopes/reviews/reviews-display/components/ReviewsBlock/ReviewsBlock.vue'

import { useSellerRatingDetails } from '../../composables/useSellerRatingDetails'
import { useSellerReviews } from '../../composables/useSellerReviews'

import translations from './ReviewsTab.translations'

const i18n = useI18n()

const props = defineProps<{
  rating?: Rating
}>()

const {
  data: reviews,
  pending: pendingReviews,
  error: reviewsError,
} = useSellerReviews()

const hasReviews = computed(() => {
  return props.rating?.count && props.rating.count > 0
})

const { data: ratingSummary, pending: ratingSummaryPending } =
  useSellerRatingDetails()
</script>
